import React, {
  useEffect,
  useRef,
  useState
} from "react";
import { Link } from "react-router-dom";

import {
  getMediaUrl
} from "../config/api";

import {
  CONTENT_TAXONOMY
} from "../config/contentTaxonomy";

function Home({
  posts = [],
  publications = [],
  isLoading = false
}) {

  const featuredPosts = posts
  .filter((post) => post.featured)
  .slice(0, 2);

  const [latestIndex, setLatestIndex] = useState(0);
  const [acrossIndex, setAcrossIndex] = useState(0);
  const [newspaperIndex, setNewspaperIndex] = useState(0);
  const [articleStripPaused, setArticleStripPaused] = useState(false);

  const homePageRef = useRef(null);
  const getSubcategoryLabel = (subcategory) => {

  if (subcategory === "Science") {
    return "Science & Technology";
  }

  if (
    subcategory === "Cultural" ||
    subcategory === "Culture" ||
    subcategory === "Ink and Echo"
  ) {
    return "Ink & Echo";
  }

  return subcategory;
};

  const getCategoryLabel = (category) =>
    category === "Photos & Videos" ||
    category === "PhotosVideos"
      ? "Media"
      : category;

  const articleSubcategories = [
  "International",
  "National",
  "State",
  "Sports",
  "Science",
  "Ink and Echo",
  "Environment",
  "Her Space",
  "Tribal Voices"
];

const normalizeArticleSubcategory = (subcategory) => {

  if (subcategory === "Science & Technology") {
    return "Science";
  }

  if (
    subcategory === "Cultural" ||
    subcategory === "Culture"
  ) {
    return "Ink and Echo";
  }

  if (subcategory === "Tribal Voice") {
    return "Tribal Voices";
  }

  return subcategory;
};

const getArticlePostTimestamp = (post) => {

  const timestamp = new Date(
    post.createdAt ||
    post.publishDate ||
    0
  ).getTime();

  return Number.isNaN(timestamp)
    ? 0
    : timestamp;
};

const formatArticleStripDate = (post) => {

  const dateValue =
    post.publishDate ||
    post.createdAt;

  if (!dateValue) {
    return "";
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return dateValue;
  }

  return date.toLocaleDateString(
    "en-IN",
    {
      day: "numeric",
      month: "short",
      year: "numeric"
    }
  );
};

const latestArticlePosts =
  articleSubcategories
    .map((subcategory) => {

      return posts
        .filter((post) => {

          return (
            post.category === "Articles" &&
            normalizeArticleSubcategory(
              post.subcategory
            ) === subcategory
          );

        })
        .sort(
          (a, b) =>
            getArticlePostTimestamp(b) -
            getArticlePostTimestamp(a)
        )[0];

    })
    .filter(Boolean)
    .sort(
      (a, b) =>
        getArticlePostTimestamp(b) -
        getArticlePostTimestamp(a)
    );

const animateArticleStrip =
  latestArticlePosts.length > 3;
  
      // =========================================
  // SIDEBAR LINK HELPERS
  // =========================================

  const findTaxonomyNode = (
  nodes,
  value
) => {

  if (!nodes || !value) {
    return null;
  }

  for (
    const [nodeKey, nodeConfig]
    of Object.entries(nodes)
  ) {

    if (
      nodeKey === value ||
      (nodeConfig.legacyValues || [])
        .includes(value)
    ) {

      return {
        key: nodeKey,
        config: nodeConfig
      };

    }

  }

  return null;
};


const getPostSidebarLink = (item) => {

  if (!item) {
    return "/";
  }

  if (item.sidebarLink) {
    return item.sidebarLink;
  }


  /*
  -----------------------------
  CATEGORY
  -----------------------------
  */

  const categoryNode =
    findTaxonomyNode(
      CONTENT_TAXONOMY,
      item.category
    );


  if (!categoryNode) {
    return "/";
  }


  let resolvedPath =
    categoryNode.config.path || "/";


  /*
  -----------------------------
  SUBCATEGORY
  -----------------------------
  */

  const subcategoryNode =
    findTaxonomyNode(
      categoryNode.config.children,
      item.subcategory
    );


  if (!subcategoryNode) {
    return resolvedPath;
  }


  if (subcategoryNode.config.path) {
    resolvedPath =
      subcategoryNode.config.path;
  }


  /*
  -----------------------------
  SUBSUBCATEGORY
  -----------------------------
  */

  const subSubcategoryNode =
    findTaxonomyNode(
      subcategoryNode.config.children,
      item.subSubcategory
    );


  if (!subSubcategoryNode) {
    return resolvedPath;
  }


  if (subSubcategoryNode.config.path) {
    resolvedPath =
      subSubcategoryNode.config.path;
  }


  return resolvedPath;
};


  const getSidebarLink = (item) => {

    if (!item) {
      return "/";
    }

    if (item.sidebarType === "publication") {

      return item.sidebarLink || (
        item.type === "book"
          ? "/publications/books"
          : item.type === "newspaper"
            ? "/publications/newspapers"
            : "/publications/magazines"
      );

    }

    return getPostSidebarLink(item);
  };


  // =========================================
  // LATEST NewspapersS
  // =========================================

  const newspaperMonthOrder = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

const latestNewspapers = [...publications]
  .filter(
    (publication) =>
      publication.type === "newspaper"
  )
  .sort((a, b) => {

    const yearDifference =
      Number(b.year || 0) -
      Number(a.year || 0);

    if (yearDifference !== 0) {
      return yearDifference;
    }

    return (
      newspaperMonthOrder.indexOf(b.month) -
      newspaperMonthOrder.indexOf(a.month)
    );

  })
  .slice(0, 3);


  // =========================================
  // LATEST UPDATES
  // =========================================

  const publicationUpdates =
    publications.map((publication) => ({
      ...publication,
      sidebarType: "publication",
      sidebarDate: publication.createdAt
        ? new Date(publication.createdAt).getTime()
        : 0
    }));


  const latestPostUpdates =
    posts.map((post) => ({
      ...post,
      sidebarType: "post",
      sidebarDate: post.createdAt
        ? new Date(post.createdAt).getTime()
        : 0
    }));


  const latestUpdates = [
    ...latestPostUpdates,
    ...publicationUpdates
  ]
    .sort(
      (a, b) =>
        b.sidebarDate - a.sidebarDate
    )
    .slice(0, 10);


  // =========================================
  // ACROSS THE SITE
  // =========================================

  const buildAcrossSiteSections = () => {

  const sections = [];

  Object.entries(CONTENT_TAXONOMY).forEach(
    ([categoryKey, categoryConfig]) => {

      const categoryValues = [
        categoryKey,
        ...(categoryConfig.legacyValues || [])
      ];

      const subcategories =
        categoryConfig.children || {};

      /*
      No subcategories:
      Editorial, Campus Report, etc.
      */
      if (
        Object.keys(subcategories).length === 0
      ) {

        sections.push({
          categories: categoryValues
        });

        return;
      }

      /*
      Category has subcategories.
      */
      Object.entries(subcategories).forEach(
        ([subcategoryKey, subcategoryConfig]) => {

          const subcategoryValues = [
            subcategoryKey,
            ...(subcategoryConfig.legacyValues || [])
          ];

          const subSubcategories =
            subcategoryConfig.children || {};

          /*
          Normal second-level leaf:
          Articles / Sports,
          News / State,
          Media / Photos, etc.
          */
          if (
            Object.keys(subSubcategories).length === 0
          ) {

            sections.push({
              categories: categoryValues,
              subcategories: subcategoryValues
            });

            return;
          }

          /*
          Third-level leaves:
          Articles / Ink and Echo / Stories
          Articles / Ink and Echo / Poems
          Articles / Ink and Echo / Articles
          */
          Object.entries(subSubcategories).forEach(
            ([
              subSubcategoryKey,
              subSubcategoryConfig
            ]) => {

              const subSubcategoryValues = [
                subSubcategoryKey,
                ...(
                  subSubcategoryConfig.legacyValues ||
                  []
                )
              ];

              sections.push({
                categories: categoryValues,
                subcategories: subcategoryValues,
                subSubcategories:
                  subSubcategoryValues
              });

            }
          );

        }
      );

    }
  );

  return sections;
};


const acrossSiteSections =
  buildAcrossSiteSections();


  const acrossPublicationSections = [
    { type: "book", label: "Publications / Books" },
    { type: "newspaper", label: "Publications / Newspapers" },
    { type: "magazine", label: "Publications / Magazines" }
  ];


  const acrossPostItems =
    acrossSiteSections
      .map((section) => {

        const matchingPosts =
          posts.filter((post) => {

            const categoryMatch =
              section.categories
                ? section.categories.includes(
                    post.category
                  )
                : post.category === section.category;

            const subcategoryMatch =
  section.subcategories
    ? section.subcategories.includes(
        post.subcategory
      )
    : true;


const subSubcategoryMatch =
  section.subSubcategories
    ? section.subSubcategories.includes(
        post.subSubcategory
      )
    : true;


return (
  categoryMatch &&
  subcategoryMatch &&
  subSubcategoryMatch
);

          });


        if (matchingPosts.length === 0) {
          return null;
        }


        const latest =
          [...matchingPosts].sort(
            (a, b) =>
              new Date(b.createdAt || 0) -
              new Date(a.createdAt || 0)
          )[0];


        return {
          ...latest,
          sidebarType: "post",
          sidebarLink:
            getPostSidebarLink(latest)
        };

      })
      .filter(Boolean);


  const acrossPublicationItems =
    acrossPublicationSections
      .map((section) => {

        const matching =
          publicationUpdates
            .filter(
              (publication) =>
                publication.type === section.type
            )
            .sort(
              (a, b) =>
                new Date(b.createdAt || 0) -
                new Date(a.createdAt || 0)
            );


        if (matching.length === 0) {
          return null;
        }


        return {
          ...matching[0],

          sidebarType: "publication",

          sidebarCategory:
            section.label,

          sidebarLink:
            section.type === "book"
              ? "/publications/books"
              : section.type === "newspaper"
                ? "/publications/newspapers"
                : "/publications/magazines"
        };

      })
      .filter(Boolean);


  const acrossSitePosts = [
    ...acrossPostItems,
    ...acrossPublicationItems
  ];


  // =========================================
  // AUTO SLIDE
  // =========================================

  useEffect(() => {

    if (latestUpdates.length <= 1) {
      return;
    }

    const timer = setInterval(() => {

      setLatestIndex((currentIndex) =>
        currentIndex === latestUpdates.length - 1
          ? 0
          : currentIndex + 1
      );

    }, 5000);

    return () => clearInterval(timer);

  }, [latestUpdates.length]);


  useEffect(() => {

    if (acrossSitePosts.length <= 1) {
      return;
    }

    const timer = setInterval(() => {

      setAcrossIndex((currentIndex) =>
        currentIndex === acrossSitePosts.length - 1
          ? 0
          : currentIndex + 1
      );

    }, 5000);

    return () => clearInterval(timer);

  }, [acrossSitePosts.length]);

  // AUTO SLIDE — LATEST NewspapersS
  useEffect(() => {

    if (latestNewspapers.length <= 1) {
      return;
    }

    const timer = setInterval(() => {

      setNewspaperIndex((currentIndex) =>
        currentIndex === latestNewspapers.length - 1
          ? 0
          : currentIndex + 1
      );

    }, 5000);

    return () => clearInterval(timer);

  }, [latestNewspapers.length]);


  // =========================================
  // PROTECT INDICES
  // =========================================

  useEffect(() => {

    if (latestUpdates.length === 0) {
      setLatestIndex(0);
      return;
    }

    if (latestIndex >= latestUpdates.length) {
      setLatestIndex(0);
    }

  }, [latestUpdates.length, latestIndex]);


  useEffect(() => {

    if (acrossSitePosts.length === 0) {
      setAcrossIndex(0);
      return;
    }

    if (acrossIndex >= acrossSitePosts.length) {
      setAcrossIndex(0);
    }

  }, [acrossSitePosts.length, acrossIndex]);

  useEffect(() => {

  if (latestNewspapers.length === 0) {
    setNewspaperIndex(0);
    return;
  }

  if (newspaperIndex >= latestNewspapers.length) {
    setNewspaperIndex(0);
  }

}, [latestNewspapers.length, newspaperIndex]);

// =========================================
  // HOMEPAGE VIEWPORT REVEAL
  // =========================================

  useEffect(() => {

    const homePageElement =
      homePageRef.current;

    if (!homePageElement) {
      return undefined;
    }

    const revealElements = [
      ...homePageElement.querySelectorAll(
        [
          ".featured-card-overlay",
          ".homepage-newspaper-slider",
          ".category-sidebar .sidebar-card"
        ].join(",")
      )
    ];

    revealElements.forEach(
      (element, index) => {

        element.classList.add(
          "homepage-reveal"
        );

        element.style.setProperty(
          "--homepage-reveal-delay",
          `${Math.min(index * 90, 270)}ms`
        );

      }
    );

    const prefersReducedMotion =
      window.matchMedia?.(
        "(prefers-reduced-motion: reduce)"
      ).matches;

    if (
      prefersReducedMotion ||
      !("IntersectionObserver" in window)
    ) {

      revealElements.forEach(
        (element) => {

          element.classList.add(
            "homepage-reveal-visible"
          );

        }
      );

      return undefined;
    }

    const revealObserver =
      new window.IntersectionObserver(
        (entries) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add(
              "homepage-reveal-visible"
            );

            revealObserver.unobserve(
              entry.target
            );

          });

        },
        {
          threshold: 0.14,

          rootMargin:
            "0px 0px -40px 0px"
        }
      );

    revealElements.forEach(
      (element) => {

        revealObserver.observe(
          element
        );

      }
    );

    return () => {

      revealObserver.disconnect();

    };

  }, [
    featuredPosts.length,
    latestNewspapers.length,
    latestUpdates.length,
    acrossSitePosts.length
  ]);

  if (isLoading) {
  return (
    <main
      ref={homePageRef}
      className="homepage home-page"
      aria-busy="true"
      aria-label="Loading homepage content"
    >

      <section className="featured-section">

        <h1>Featured Posts</h1>

        <div className="featured-grid homepage-skeleton-grid">

          {[0, 1].map((item) => (

            <div
              key={item}
              className="homepage-skeleton-card homepage-skeleton-feature"
              aria-hidden="true"
            >

              <span className="homepage-skeleton-piece homepage-skeleton-badge" />

              <span className="homepage-skeleton-piece homepage-skeleton-title" />

              <span className="homepage-skeleton-piece homepage-skeleton-title-short" />

              <span className="homepage-skeleton-piece homepage-skeleton-meta" />

            </div>

          ))}

        </div>

      </section>


      <div
        className="homepage-section-separator"
        aria-hidden="true"
      />


      <div className="category-main-layout homepage-skeleton-layout">

        <section className="category-posts-section homepage-newspapers-section">

          <h1>Latest Newspapers</h1>

          <div
            className="homepage-skeleton-card homepage-skeleton-newspaper"
            aria-hidden="true"
          >

            <span className="homepage-skeleton-piece homepage-skeleton-badge" />

            <span className="homepage-skeleton-piece homepage-skeleton-title" />

            <span className="homepage-skeleton-piece homepage-skeleton-meta" />

          </div>

        </section>


        <aside className="category-sidebar">

          {[
            "Latest Updates",
            "Across the Site"
          ].map((heading) => (

            <div
              key={heading}
              className="sidebar-card sidebar-feature-card"
            >

              <h2>{heading}</h2>

              <div className="sidebar-placeholder">

                <div
                  className="homepage-skeleton-card homepage-skeleton-sidebar"
                  aria-hidden="true"
                >

                  <span className="homepage-skeleton-piece homepage-skeleton-badge" />

                  <span className="homepage-skeleton-piece homepage-skeleton-title" />

                  <span className="homepage-skeleton-piece homepage-skeleton-title-short" />

                  <span className="homepage-skeleton-piece homepage-skeleton-meta" />

                </div>

              </div>

            </div>

          ))}

        </aside>

      </div>

    </main>
  );
}

  return (
    <main
  ref={homePageRef}
  className="homepage home-page"
>

  {/* LATEST FROM ARTICLES */}

  <section
    className="homepage-article-strip-section"
    aria-labelledby="homepage-article-strip-title"
  >

    <div className="homepage-article-strip-heading">

      <div className="homepage-article-strip-heading-copy">

        <h1 id="homepage-article-strip-title">
          Article Highlights
        </h1>

      </div>

      {animateArticleStrip && (

        <button
          type="button"
          className="homepage-article-strip-toggle"
          aria-pressed={articleStripPaused}
          aria-label={
            articleStripPaused
              ? "Resume latest articles movement"
              : "Pause latest articles movement"
          }
          onClick={() =>
            setArticleStripPaused(
              (currentValue) => !currentValue
            )
          }
        >
          {articleStripPaused
            ? "Resume"
            : "Pause"}
        </button>

      )}

    </div>

    {latestArticlePosts.length === 0 ? (

      <div
        className="homepage-article-strip-empty"
        role="status"
      >
        Latest Articles will appear here when published.
      </div>

    ) : (

      <div
        className="homepage-article-strip-window"
        aria-label="Latest posts from Articles"
      >

        <div
          className={[
            "homepage-article-strip-track",
            articleStripPaused
              ? "is-paused"
              : "",
            !animateArticleStrip
              ? "is-static"
              : ""
          ].filter(Boolean).join(" ")}
          style={{
            "--homepage-article-duration":
              `${Math.max(
                38,
                latestArticlePosts.length * 5
              )}s`
          }}
        >

          {(animateArticleStrip
            ? [0, 1]
            : [0]
          ).map((groupIndex) => (

            <div
              key={groupIndex}
              className="homepage-article-strip-group"
              aria-hidden={
                groupIndex === 1
                  ? "true"
                  : undefined
              }
            >

              {latestArticlePosts.map((post) => {

                const imageSrc =
                  post.coverImage
                    ? getMediaUrl(post.coverImage)
                    : post.image
                      ? getMediaUrl(post.image)
                      : "/default-cover.jpg";

                const displayDate =
                  formatArticleStripDate(post);

                return (

                  <Link
                    key={`${groupIndex}-${post._id}`}
                    to={`/post/${post._id}`}
                    className="homepage-article-strip-card"
                    tabIndex={
                      groupIndex === 1
                        ? -1
                        : undefined
                    }
                  >

                    <span className="homepage-article-strip-image">

                      <img
                        src={imageSrc}
                        alt=""
                        loading="lazy"
                      />

                    </span>

                    <span className="homepage-article-strip-content">

                      <small>
                        {post.subcategory
                          ? getSubcategoryLabel(
                              post.subcategory
                            )
                          : "Articles"}
                      </small>

                      <h2>
                        {post.title}
                      </h2>

                      {displayDate && (
                        <time>
                          {displayDate}
                        </time>
                      )}

                    </span>

                  </Link>

                );

              })}

            </div>

          ))}

        </div>

      </div>

    )}

  </section>

  {/* HERO SECTION */}
  {/* FEATURED POSTS */}
      <section className="featured-section">

        <h1>Featured Posts</h1>

        {featuredPosts.length === 0 ? (
          <div
  className="homepage-empty-state homepage-empty-featured"
  role="status"
>
  <span
    className="homepage-empty-state-icon"
    aria-hidden="true"
  >
    ★
  </span>

  <strong>No featured posts yet</strong>

  <small>
    Featured stories will appear here when selected.
  </small>
</div>
        ) : (

      <div className="featured-grid">

          {featuredPosts.map((post) => {

            const imageSrc =
              post.coverImage
                ? getMediaUrl(post.coverImage)
                : post.type === "image" && post.image
                  ? getMediaUrl(post.image)
                  : "/default-cover.jpg";

            return (

            <div
                key={post._id}
                className="featured-card-overlay"
            >

                <Link
                    to={`/post/${post._id}`}
                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        width: "100%",
                        height: "100%",
                        display: "block"
                    }}
                >

                    <img
                        src={imageSrc}
                        alt={post.title}
                    />

                    <div className="featured-overlay">

                        <div className="featured-content">

                            <div className="featured-category">

                              {getCategoryLabel(post.category)}

                            </div>

                            <h2>

                                {post.title.length > 70
                                    ? post.title.substring(0, 70) + "..."
                                    : post.title}

                            </h2>

                            <small>

                                {post.writer && (
                                    <>
                                        {post.writer}
                                        {" • "}
                                    </>
                                )}

                                {post.publishDate}

                                {post.readingTime && (
                                    <>
                                        {" • "}
                                        {post.readingTime}
                                    </>
                                )}

                            </small>

                            <span className="read-more-button">

                                Read More

                            </span>

                        </div>

                    </div>

                </Link>

            </div>
            );

      })}

        </div>

    )}
      </section>

<div
  className="homepage-section-separator"
  aria-hidden="true"
/>

{/* =========================================
    HOMEPAGE LOWER SECTION
========================================= */}

      <div className="category-main-layout">

        {/* =========================================
            LEFT — LATEST NewspapersS
        ========================================== */}

        <section className="category-posts-section homepage-newspapers-section">

          <h1>Latest Newspapers</h1>

          {latestNewspapers.length === 0 ? (

            <div
  className="homepage-empty-state homepage-empty-newspaper"
  role="status"
>
  <span
    className="homepage-empty-state-icon"
    aria-hidden="true"
  >
    ▤
  </span>

  <strong>No newspaper issues yet</strong>

  <small>
    Uploaded issues will appear here automatically.
  </small>
</div>

          ) : (

            <div className="homepage-newspaper-slider">

              <div
                key={`${latestNewspapers[newspaperIndex]._id}-${newspaperIndex}`}
                className={`publication-overlay-card newspaper-card homepage-newspaper-slide newspaper-slide-animate ${
                  latestNewspapers[newspaperIndex].coverImage
                    ? "has-image"
                    : "no-image"
                }`}
                style={
                  latestNewspapers[newspaperIndex].coverImage
                    ? {
                        backgroundImage:
                          `url("${getMediaUrl(
                              latestNewspapers[newspaperIndex].coverImage
                            )}")`
                      }
                    : {}
                }
              >

                <div className="publication-overlay-content">

                  {!latestNewspapers[newspaperIndex].coverImage && (
                    <div className="publication-no-image-icon">
                      📰
                    </div>
                  )}

          <div className="featured-category homepage-newspaper-category">
            Newspapers
          </div>

          <h3>
            {latestNewspapers[newspaperIndex].month}{" "}
            {latestNewspapers[newspaperIndex].year}
          </h3>

                  <p>
                    ছাত্র সংবাদ — Monthly Issue
                  </p>

                  <a
                    href={getMediaUrl(
                      latestNewspapers[newspaperIndex].pdf
                    )}
                    target="_blank"
                    rel="noreferrer"
                    className="publication-read-button"
                  >
                    Open Issue
                  </a>

                </div>

              </div>


              {latestNewspapers.length > 1 && (

                <div className="newspaper-navigation">

                  <button
                    type="button"
                    onClick={() =>
                      setNewspaperIndex(
                        newspaperIndex === 0
                          ? latestNewspapers.length - 1
                          : newspaperIndex - 1
                      )
                    }
                  >
                    ←
                  </button>

          <div className="homepage-sidebar-progress">

            <div
              className="homepage-sidebar-dots"
              aria-label="Latest Newspaper slides"
            >

              {latestNewspapers.map(
                (newspaper, indicatorIndex) => (

                  <button
                    key={
                      `newspaper-indicator-${
                        newspaper._id || indicatorIndex
                      }-${indicatorIndex}`
                    }
                    type="button"
                    className={
                      [
                        "homepage-sidebar-dot",
                        newspaperIndex === indicatorIndex
                          ? "active"
                          : ""
                      ]
                        .filter(Boolean)
                        .join(" ")
                    }
                    aria-label={
                      `Show newspaper issue ${
                        indicatorIndex + 1
                      }`
                    }
                    aria-current={
                      newspaperIndex === indicatorIndex
                        ? "true"
                        : undefined
                    }
                    onClick={() =>
                      setNewspaperIndex(
                        indicatorIndex
                      )
                    }
                  />

                )
              )}

            </div>

          </div>

                  <button
                    type="button"
                    onClick={() =>
                      setNewspaperIndex(
                        newspaperIndex === latestNewspapers.length - 1
                          ? 0
                          : newspaperIndex + 1
                      )
                    }
                  >
                    →
                  </button>

                </div>

              )}

            </div>

          )}

        </section>


        {/* =========================================
            RIGHT — SIDEBAR
        ========================================== */}

        <aside className="category-sidebar">

          {/* =========================================
              LATEST UPDATES
          ========================================== */}

          <div className="sidebar-card sidebar-feature-card">

            <h2>
              Latest Updates
            </h2>

            <div className="sidebar-placeholder">

              {latestUpdates.length > 0 ? (

                <>

                  <Link
                    to={getSidebarLink(
                      latestUpdates[latestIndex]
                    )}
                    className="sidebar-slide-link"
                  >

                    <div
                      key={`latest-${latestUpdates[latestIndex]._id}-${latestIndex}`}
                      className="sidebar-slide sidebar-feature-slide sidebar-slide-animate"
                      style={{
                        backgroundImage:
                          `url("${
                            latestUpdates[latestIndex].coverImage
                              ? getMediaUrl(
                                  latestUpdates[latestIndex].coverImage
                                )
                              : latestUpdates[latestIndex].image
                                ? getMediaUrl(
                                    latestUpdates[latestIndex].image
                                  )
                                : "/default-cover.jpg"
                          }")`
                      }}
                    >

                      <div className="sidebar-feature-overlay">

                        <div className="sidebar-feature-content">

                          <small className="sidebar-feature-category">

  {latestUpdates[latestIndex].sidebarType === "publication"
    ? (
        latestUpdates[latestIndex].type === "book"
          ? "Publications / Books"
          : latestUpdates[latestIndex].type === "newspaper"
            ? "Publications / Newspapers"
            : "Publications / Magazines"
      )
    : (
        <>
          {getCategoryLabel(
            latestUpdates[latestIndex].category
          )}

          {latestUpdates[latestIndex].subcategory && (
            <>
              {" / "}
              {getSubcategoryLabel(
                latestUpdates[latestIndex].subcategory
              )}
            </>
          )}

          {latestUpdates[latestIndex].subSubcategory && (
            <>
              {" / "}
              {latestUpdates[latestIndex].subSubcategory}
            </>
          )}
        </>
      )}

</small>

                          <h3>
                            {latestUpdates[latestIndex].title}
                          </h3>


                          {latestUpdates[latestIndex].sidebarType ===
                            "publication" &&
                            latestUpdates[latestIndex].description && (

                              <p className="sidebar-feature-description">

                                {latestUpdates[latestIndex].description.substring(
                                  0,
                                  120
                                )}

                                {latestUpdates[latestIndex].description.length > 120
                                  ? "..."
                                  : ""}

                              </p>

                          )}


                          {latestUpdates[latestIndex].sidebarType ===
                            "publication" &&
                            latestUpdates[latestIndex].author && (

                              <p className="sidebar-feature-author">

                                By {latestUpdates[latestIndex].author}

                              </p>

                          )}


                          {latestUpdates[latestIndex].sidebarType !==
                            "publication" &&
                            latestUpdates[latestIndex].writer && (

                              <p className="sidebar-feature-author">

                                By {latestUpdates[latestIndex].writer}

                              </p>

                          )}

                        </div>

                      </div>

                    </div>

                  </Link>


                  <div className="sidebar-navigation">

                    <button
                      type="button"
                      onClick={() =>
                        setLatestIndex(
                          latestIndex === 0
                            ? latestUpdates.length - 1
                            : latestIndex - 1
                        )
                      }
                    >
                      ←
                    </button>

              <div className="homepage-sidebar-progress">

                <div
                  className="homepage-sidebar-dots"
                  aria-label="Latest Updates slides"
                >

                  {latestUpdates.map(
                    (item, indicatorIndex) => (

                      <button
                        key={
                          `latest-indicator-${
                            item._id || indicatorIndex
                          }-${indicatorIndex}`
                        }
                        type="button"
                        className={
                          [
                            "homepage-sidebar-dot",
                            latestIndex === indicatorIndex
                              ? "active"
                              : ""
                          ]
                            .filter(Boolean)
                            .join(" ")
                        }
                        aria-label={
                          `Show Latest Update ${
                            indicatorIndex + 1
                          }`
                        }
                        aria-current={
                          latestIndex === indicatorIndex
                            ? "true"
                            : undefined
                        }
                        onClick={() =>
                          setLatestIndex(
                            indicatorIndex
                          )
                        }
                      />

                    )
                  )}

                </div>

              </div>

                    <button
                      type="button"
                      onClick={() =>
                        setLatestIndex(
                          latestIndex === latestUpdates.length - 1
                            ? 0
                            : latestIndex + 1
                        )
                      }
                    >
                      →
                    </button>

                  </div>

                </>

              ) : (

                <div
  className="homepage-empty-state homepage-empty-sidebar"
  role="status"
>
  <span
    className="homepage-empty-state-icon"
    aria-hidden="true"
  >
    ↻
  </span>

  <strong>No latest updates available</strong>

  <small>
    New posts and publications will appear here.
  </small>
</div>

              )}

            </div>

          </div>


          {/* =========================================
              ACROSS THE SITE
          ========================================== */}

          <div className="sidebar-card sidebar-feature-card">

            <h2>
              Across the Site
            </h2>

            <div className="sidebar-placeholder">

              {acrossSitePosts.length > 0 ? (

                <>

                  <Link
                    to={getSidebarLink(
                      acrossSitePosts[acrossIndex]
                    )}
                    className="sidebar-slide-link"
                  >

                    <div
                      key={`across-${acrossSitePosts[acrossIndex]._id}-${acrossIndex}`}
                      className="sidebar-slide sidebar-feature-slide sidebar-slide-animate"
                      style={{
                        backgroundImage:
                          `url("${
                            acrossSitePosts[acrossIndex].coverImage
                              ? getMediaUrl(
                                  acrossSitePosts[acrossIndex].coverImage
                                )
                              : acrossSitePosts[acrossIndex].image
                                ? getMediaUrl(
                                    acrossSitePosts[acrossIndex].image
                                  )
                                : "/default-cover.jpg"
                          }")`
                      }}
                    >

                      <div className="sidebar-feature-overlay">

                        <div className="sidebar-feature-content">

                          <small className="sidebar-feature-category">

  {acrossSitePosts[acrossIndex].sidebarType === "publication"
    ? (
        acrossSitePosts[acrossIndex].sidebarCategory ||
        (
          acrossSitePosts[acrossIndex].type === "book"
            ? "Publications / Books"
            : acrossSitePosts[acrossIndex].type === "newspaper"
              ? "Publications / Newspapers"
              : "Publications / Magazines"
        )
      )
    : (
        <>
          {getCategoryLabel(
            acrossSitePosts[acrossIndex].category
          )}

          {acrossSitePosts[acrossIndex].subcategory && (
            <>
              {" / "}
              {getSubcategoryLabel(
                acrossSitePosts[acrossIndex].subcategory
              )}
            </>
          )}

          {acrossSitePosts[acrossIndex].subSubcategory && (
            <>
              {" / "}
              {acrossSitePosts[acrossIndex].subSubcategory}
            </>
          )}
        </>
      )}

</small>

                          <h3>
                            {acrossSitePosts[acrossIndex].title}
                          </h3>


                          {acrossSitePosts[acrossIndex].sidebarType ===
                            "publication" &&
                            acrossSitePosts[acrossIndex].author && (

                              <p className="sidebar-feature-author">

                                By {acrossSitePosts[acrossIndex].author}

                              </p>

                          )}


                          {acrossSitePosts[acrossIndex].sidebarType !==
                            "publication" &&
                            acrossSitePosts[acrossIndex].writer && (

                              <p className="sidebar-feature-author">

                                By {acrossSitePosts[acrossIndex].writer}

                              </p>

                          )}

                        </div>

                      </div>

                    </div>

                  </Link>


                  <div className="sidebar-navigation">

                    <button
                      type="button"
                      onClick={() =>
                        setAcrossIndex(
                          acrossIndex === 0
                            ? acrossSitePosts.length - 1
                            : acrossIndex - 1
                        )
                      }
                    >
                      ←
                    </button>

              <div className="homepage-sidebar-progress">

                <div
                  className="homepage-sidebar-dots"
                  aria-label="Across the Site slides"
                >

                  {acrossSitePosts.map(
                    (item, indicatorIndex) => (

                      <button
                        key={
                          `across-indicator-${
                            item._id || indicatorIndex
                          }-${indicatorIndex}`
                        }
                        type="button"
                        className={
                          [
                            "homepage-sidebar-dot",
                            acrossIndex === indicatorIndex
                              ? "active"
                              : ""
                          ]
                            .filter(Boolean)
                            .join(" ")
                        }
                        aria-label={
                          `Show Across the Site item ${
                            indicatorIndex + 1
                          }`
                        }
                        aria-current={
                          acrossIndex === indicatorIndex
                            ? "true"
                            : undefined
                        }
                        onClick={() =>
                          setAcrossIndex(
                            indicatorIndex
                          )
                        }
                      />

                    )
                  )}

                </div>

              </div>

                    <button
                      type="button"
                      onClick={() =>
                        setAcrossIndex(
                          acrossIndex === acrossSitePosts.length - 1
                            ? 0
                            : acrossIndex + 1
                        )
                      }
                    >
                      →
                    </button>

                  </div>

                </>

              ) : (

                <div
  className="homepage-empty-state homepage-empty-sidebar"
  role="status"
>
  <span
    className="homepage-empty-state-icon"
    aria-hidden="true"
  >
    ◇
  </span>

  <strong>No content available</strong>

  <small>
    More sections will appear as content is published.
  </small>
</div>

              )}

            </div>

          </div>

        </aside>

      </div>

    </main>
  );
}

export default Home;